import { type DirectiveBinding, type ObjectDirective } from 'vue'
import { useUserStore } from '@/stores/UserStore'
//add 'v-authenticated' directive
interface AuthenticatedHTMLElement extends HTMLElement {
  __clickHandler: (event) => void
}

const authenticatedDirective: ObjectDirective<HTMLElement, any> = {
  mounted(el: AuthenticatedHTMLElement, binding: DirectiveBinding<any>) {
    let dispatching = false
    const userStore = useUserStore()
    async function onClick(event) {
      if (binding.value == false) {
        return
      }
      if (!dispatching) {
        event.preventDefault()
        event.stopImmediatePropagation()
        await userStore.checkState()
        if (userStore.user.isLogin) {
          if (binding.arg === 'memberRequired' && null == userStore.user.isMember) {
            const svc = await import('@/services/dialogs/MemberDialogService')
            const scene = binding.value != null ? binding.value.scene : null
            svc.openRegister(scene, async () => {
              await userStore.checkState()
              if (userStore.user.isMember) {
                const newEvent = new Event(event.type, {
                  bubbles: event.bubbles,
                  cancelable: event.cancelable
                })
                dispatching = true
                event.target.dispatchEvent(newEvent)
                return
              }
            })
          } else {
            const newEvent = new Event(event.type, {
              bubbles: event.bubbles,
              cancelable: event.cancelable
            })
            dispatching = true
            event.target.dispatchEvent(newEvent)
            return
          }
        } else {
          userStore.requestLogin((loginResult) => {
            if (loginResult === true) {
              const newEvent = new Event(event.type, {
                bubbles: event.bubbles,
                cancelable: event.cancelable
              })
              if (binding.arg === 'memberRequired') {
                dispatching = false
              } else {
                dispatching = true
              }
              event.target.dispatchEvent(newEvent)
            }
          })
        }
      } else {
        dispatching = false
      }
    }
    el.addEventListener('click', onClick, true)
    el.__clickHandler = onclick
  },
  beforeUnmount(el: AuthenticatedHTMLElement, binding: DirectiveBinding<any>) {
    el.removeEventListener('click', el.__clickHandler, { capture: true })
  }
}

export default authenticatedDirective
